import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "../ui/tooltip";
import { features } from "../lib/features";
import { Home, Settings } from "lucide-react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export const SideBar = () => {
    const location = useLocation().pathname.split("/");
    return (
        <aside className="fixed inset-y-0 left-0 z-10 hidden w-14 flex-col border-r bg-background sm:flex">
            <nav className="flex flex-col items-center gap-4 px-2 sm:py-5">
                <Link
                    to="/"
                    className="group flex h-9 w-9 shrink-0 items-center justify-center gap-2 rounded-full bg-primary text-lg font-semibold text-primary-foreground md:h-8 md:w-8 md:text-base"
                >
                    <Home className="h-4 w-4 transition-all group-hover:scale-110" />
                    <span className="sr-only">Udyog</span>
                </Link>
                {features.map(({ name, icon, link }, id) => (
                    <TooltipProvider key={id}>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Link
                                    to={`/user${link}`}
                                    className={`flex h-9 w-9 items-center justify-center rounded-lg transition-colors hover:text-foreground md:h-8 md:w-8 ${
                                        location.at(-1) == name
                                            ? "bg-primary/35 text-accent-foreground"
                                            : "text-muted-foreground"
                                    }`}                                >
                                    {icon}
                                    <span className="sr-only capitalize">
                                        {name}
                                    </span>
                                </Link>
                            </TooltipTrigger>
                            <TooltipContent side="right" className="capitalize">
                                {name}
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
            ))}
            </nav>
            <nav className="mt-auto flex flex-col items-center gap-4 px-2 sm:py-5">
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Link
                                href="#"
                                className="flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:text-foreground md:h-8 md:w-8"
                            >
                                <Settings className="h-5 w-5" />
                                <span className="sr-only">Settings</span>
                            </Link>
                        </TooltipTrigger>
                        <TooltipContent side="right">Settings</TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            </nav>
        </aside>
    );
};
